// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"d806910a","347":"796691a7"}[chunkId] + ".chunk.js";
};